module.exports = __webpack_public_path__ + "img/loading-line-50px.69809695.gif";